import React, {useEffect, useState} from 'react';
import { View, Text } from 'react-native';

const MultiStyleVernacText = (props) => {
        const {
                content = "",
                defaultContentStyle = {},
                viewStyle = {},
                textStyles = {},
                params = {},
                contentHorizontal = false
        } = props;

        const [tokenWithStyles, setTokenWithStyles] = useState([]);

        const processParametrizedContent = () => {
                const resList = [];
                let tokenStartIndex = 0;
                let tokenEndIndex = 0;
                let contentLength = content.length;

                while(tokenStartIndex < contentLength) {
                        tokenEndIndex = content.indexOf("{{", tokenStartIndex);
                        // if a special token exists
                        if(tokenEndIndex > -1) {
                                const regularTextTokenBeforeSpecialText = content.substring(tokenStartIndex, tokenEndIndex);
                                // if a regular token exist before special one
                                if(regularTextTokenBeforeSpecialText.length > 0) {
                                        resList.push([regularTextTokenBeforeSpecialText, defaultContentStyle]);
                                }

                                // special token key
                                tokenStartIndex = tokenEndIndex + 2;
                                tokenEndIndex = content.indexOf("}}", tokenStartIndex);
                                const key = content.substring(tokenStartIndex, tokenEndIndex);
                                resList.push([params[key], textStyles[key]]);
                                // search searching after     ....{{key}}from Here Onwards
                                tokenStartIndex = tokenEndIndex + 2;

                        } else {
                                const regularTextToken = content.substring(tokenStartIndex, contentLength);
                                resList.push([regularTextToken,defaultContentStyle]);
                                tokenStartIndex = contentLength;
                        }
                }
                return resList;
        }

        useEffect(() => {
                const processedTextList = processParametrizedContent();
                setTokenWithStyles(processedTextList);
        },[]);
        return <View style = {viewStyle}>
                {contentHorizontal && <Text>
                        {tokenWithStyles.map((element) => {
                                const [text, textStyle] = element;
                                return <Text style={textStyle || defaultContentStyle}>
                                        {text}
                                </Text>
                        })}
                </Text>}
                {!contentHorizontal &&
                        tokenWithStyles.map((element) => {
                                const [text, textStyle] = element;
                                return <Text style={textStyle || defaultContentStyle}>
                                        {text}
                                </Text>
                        })}
        </View>

}

export default MultiStyleVernacText;
